import React from 'react';
import { Badge } from '../ui/badge';

const STYLES = {
  sent: 'bg-[#00E676]/15 text-[#00E676]',
  queued: 'bg-[#00E5FF]/15 text-[#00E5FF]',
  pending: 'bg-[#00E5FF]/15 text-[#00E5FF]',
  sending: 'bg-[#00E5FF]/25 text-[#00E5FF]',
  bounced: 'bg-[#FF5252]/15 text-[#FF5252]',
  failed: 'bg-[#FF5252]/15 text-[#FF5252]',
  hard_bounce: 'bg-[#FF5252]/15 text-[#FF5252]',
  invalid_domain: 'bg-[#FF9100]/15 text-[#FF9100]',
  soft_bounce_threshold: 'bg-[#FF9100]/15 text-[#FF9100]',
  suppressed: 'bg-[#FF9100]/15 text-[#FF9100]',
  blocked: 'bg-[#FF9100]/15 text-[#FF9100]',
  manual: 'bg-[#B388FF]/15 text-[#B388FF]',
  cancelled: 'bg-white/10 text-[#A0B4CC]',
  duplicate: 'bg-white/10 text-[#A0B4CC]',
};

export function StatusBadge({ value, testId }) {
  return (
    <Badge className={`border-0 capitalize ${STYLES[value] || 'bg-white/10 text-[#A0B4CC]'}`} data-testid={testId}>
      {(value || '—').replace(/_/g, ' ')}
    </Badge>
  );
}

export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleString() : '—');
